import { UTCDate } from '@date-fns/utc';
import { isValid } from 'date-fns';
import { InvoiceEvidenceView } from '../../../types/entity-types';

export const hasValidDueDate = (
  evidence: InvoiceEvidenceView,
): evidence is InvoiceEvidenceView & {
  billingDates: {
    dueDate: string;
  };
} => {
  return !!evidence.billingDates?.dueDate && isValid(new UTCDate(evidence.billingDates.dueDate));
};
